import { render, staticRenderFns } from "./RTDispersionConfirmation.vue?vue&type=template&id=c8f056ec&scoped=true"
import script from "./RTDispersionConfirmation.vue?vue&type=script&lang=js"
export * from "./RTDispersionConfirmation.vue?vue&type=script&lang=js"
import style0 from "./RTDispersionConfirmation.vue?vue&type=style&index=0&id=c8f056ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f056ec",
  null
  
)

export default component.exports